import React from 'react';
import { Link } from 'react-router-dom';

export const PRIMARY = '#273A81';

// Grup başlığı - warranty dashboard'daki SectionTitle deseniyle aynı (gri şerit).
// Eğitim Planlama (my-trainings) ve Yönetim Sayfaları arasında paylaşılır.
export const SectionTitle = ({ title }) => (
    <div style={{ margin: 0 }}>
        <h2
            style={{
                color: '#FFFFFF',
                fontSize: '1rem',
                fontWeight: 600,
                backgroundColor: '#8e8e93',
                padding: '12px 16px',
                display: 'block',
                margin: 0
            }}
        >
            {title}
        </h2>
    </div>
);

// `to` verilmişse satır gerçek bir sayfaya bağlanır (aktif); verilmezse içerik/route
// netleşene kadar disabled görünümde kalır.
export const LinkRow = ({ title, icon, to, showDivider = true }) => {
    const content = (
        <div className="flex align-items-center gap-2" style={to ? undefined : { opacity: 0.55 }}>
            <i className={`pi ${icon}`} style={{ fontSize: '1.1rem', color: to ? PRIMARY : '#6B7280' }} />
            <span style={{ fontSize: '0.95rem', color: to ? PRIMARY : '#6B7280' }}>{title}</span>
        </div>
    );

    return (
        <>
            {to ? (
                <Link to={to} className="p-3 block no-underline" style={{ cursor: 'pointer' }}>
                    {content}
                </Link>
            ) : (
                <div className="p-3" style={{ cursor: 'not-allowed' }} title="Bu özellik yakında aktif olacak">
                    {content}
                </div>
            )}
            {showDivider && <div style={{ borderTop: '1px solid #E5E7EB', margin: 0 }} />}
        </>
    );
};

export const cardStyle = {
    border: '1px solid #D7DCE7',
    borderRadius: '6px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
    overflow: 'hidden'
};

export const cardPt = {
    body: { style: { padding: 0 } },
    content: { style: { padding: 0 } }
};
